module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKUlEQVQ4T2NgGBTg707h/+Tg4WQAQ5bLf7Lw4DHgoLruf3LwcDJgaAMAI6hWkvhzB/EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LT.png
// module id = 1196
// module chunks = 0